var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

function WssidWS(viewModel) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.delegate = null;
  self.name = 'WssidWS';			// Convenience name for debugging
  self.wssid = ko.observable(null);


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/wssid';
  });


	/**
	 * Inspects an API return for a WSSIDException error
	 *
	 * @method checkResponseForError
	 * @param {XMLString} data
	 * @returns {Boolean}
	 */
  self.checkResponseForError = function (data) {
    return false;
  };


	/**
	 * This method iterates over the data returned from the service and
	 * converts the individual nodes into LocationModels and then assigns
	 * them to this object's locations collection.
	 *
	 * @method processData
	 * @param {XMLString} xmlData XML data returned from the service
	 * @returns {LocationsWS} Returns the object as chainable, for best practice
	 */
  self.processData = function (xmlData) {
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    var json = xmlToJson.parse(xmlData);

    self.wssid(json.wssid);

    if (self.delegate != null) {
      self.delegate();
      self.delegate = null;
    }

    return self;
  };

  return self;
};

WssidWS.prototype = AbstractWS.prototype;
WssidWS.prototype.constructor = WssidWS;

module.exports = WssidWS
